import styled, { keyframes, css } from 'styled-components';
import { globePin, markerPin, globePinHover, markerPinHover, globePinSelected, markerPinSelected } from './mapMarkers.js';
import { markerUrls, markerUrlsNoColour } from './markerUrls.js';
import mq from '../../utils/mediaQueries.js';

// @ts-nocheck
var markerInitAnimation = keyframes(["0%{opacity:0;top:-8px;}100%{opacity:1;top:0;}"]);
var MapRootContainer = styled.div.withConfig({
  displayName: "style__MapRootContainer",
  componentId: "sc-zfg7q7-0"
})(["height:100%;left:0;overflow:hidden;position:fixed;top:0;width:100%;z-index:1;", ""], mq.s(css(["height:707px;left:auto;position:relative;top:auto;"])));
var CloseButton = styled.button.withConfig({
  displayName: "style__CloseButton",
  componentId: "sc-zfg7q7-1"
})(["position:absolute;right:12px;top:12px;box-sizing:border-box;height:41px;width:41px;z-index:4;color:var(--color-black);cursor:pointer;display:block;background:var(--color-white);border:var(--color-grey-400) solid 1px;border-radius:100%;display:flex;justify-content:center;align-items:center;"]);
var Marker = styled.div.withConfig({
  displayName: "style__Marker",
  componentId: "sc-zfg7q7-2"
})(["animation-duration:0.5s;animation-name:", ";background-size:cover;cursor:pointer;left:0;opacity:1;position:absolute;text-align:left;top:0;transform:translate(-50%,-100%);transition:all var(--transition);", " ", " ", ""], markerInitAnimation, function (_ref) {
  var $disableAnimation = _ref.$disableAnimation;
  return $disableAnimation && css(["animation:none;"]);
}, function (_ref2) {
  var $isHovered = _ref2.$isHovered,
    $isSelected = _ref2.$isSelected,
    $type = _ref2.$type,
    $isGlobetrotter = _ref2.$isGlobetrotter;
  return $type === 'hotel' && css(["background-image:url(", ");height:", ";width:", ";", " ", ""], $isGlobetrotter ? globePin : markerPin, $isGlobetrotter ? '38px' : '38px', $isGlobetrotter ? '32px' : '28px', mq.s(css(["", ""], $isHovered && css(["background-image:url(", ");z-index:2;"], $isGlobetrotter ? globePinHover : markerPinHover))), $isSelected && css(["background-image:url(", ");z-index:1;height:", ";width:", ";"], $isGlobetrotter ? globePinSelected : markerPinSelected, $isGlobetrotter ? '48px' : '46px', $isGlobetrotter ? '40px' : '36px'));
}, function (_ref3) {
  var $isHovered = _ref3.$isHovered,
    $isSelected = _ref3.$isSelected,
    $type = _ref3.$type;
  return $type !== 'hotel' && css(["background-image:url('//img.nltg.com/image/upload", ".svg');height:38px;width:35px;transition-property:none;", " ", ""], markerUrls[$type], mq.s(css(["", ""], $isHovered && css(["z-index:2;"]))), $isSelected && css(["background-image:url('//img.nltg.com/image/upload", ".svg');z-index:1;height:46px;width:43px;"], markerUrlsNoColour[$type]));
});
var InfoCard = styled.div.withConfig({
  displayName: "style__InfoCard",
  componentId: "sc-zfg7q7-3"
})(["background-color:var(--color-white);display:none;margin-left:50%;position:absolute;top:0;width:272px;z-index:3;", " ", " .sg-infocard__thumbnail{height:auto;width:100%;vertical-align:middle;}"], function (_ref4) {
  var $position = _ref4.$position,
    $markerSelected = _ref4.$markerSelected;
  switch ($position) {
    case 'top-left':
      return css(["transform:translate(-100%,-100%);"]);
    case 'top-center':
      return css(["transform:translate(-50%,-100%);"]);
    case 'top-right':
      return css(["transform:translate(0%,-100%);"]);
    case 'bottom-left':
      return $markerSelected ? css(["transform:translate(-100%,46px);"]) : css(["transform:translate(-100%,38px);"]);
    case 'bottom-center':
      return $markerSelected ? css(["transform:translate(-50%,46px);"]) : css(["transform:translate(-50%,38px);"]);
    case 'bottom-right':
      return $markerSelected ? css(["transform:translate(0%,46px);"]) : css(["transform:translate(0%,38px);"]);
    default:
      return css(["transform:translate(-50%,-100%);"]);
  }
}, mq.s(css(["display:", ";"], function (_ref5) {
  var $isHidden = _ref5.$isHidden;
  return $isHidden ? 'none' : 'block';
})));
var InfoCardContainer = styled.div.withConfig({
  displayName: "style__InfoCardContainer",
  componentId: "sc-zfg7q7-4"
})(["display:flex;flex-direction:column;"]);
var InfoCardThumbnail = styled.div.withConfig({
  displayName: "style__InfoCardThumbnail",
  componentId: "sc-zfg7q7-5"
})(["flex:1 auto;"]);
var InfoCardBody = styled.div.withConfig({
  displayName: "style__InfoCardBody",
  componentId: "sc-zfg7q7-6"
})(["display:flex;flex-direction:column;"]);
var InfoCardHeader = styled.div.withConfig({
  displayName: "style__InfoCardHeader",
  componentId: "sc-zfg7q7-7"
})(["font-family:var(--font-family-thomas-headline);font-weight:700;font-size:18px;padding:8px;color:var(--color-text);"]);
var InfoCardContent = styled.div.withConfig({
  displayName: "style__InfoCardContent",
  componentId: "sc-zfg7q7-8"
})(["flex:1;"]);

export { CloseButton, InfoCard, InfoCardBody, InfoCardContainer, InfoCardContent, InfoCardHeader, InfoCardThumbnail, MapRootContainer, Marker };
//# sourceMappingURL=style.js.map
